var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('param-box',{staticClass:"border border-red-400 dark:border-red-700 bg-red-300 dark:bg-red-900",attrs:{"title":_vm.title,"icon":_vm.icon}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }